// create an enum for the different states of the widget
export const ChatState = {
  ACTIVE: 0, // user able to input messages
  LOADING: 1, // waiting for a response from the server
  INACTIVE: 2, // widget is not active
};

export const ChatSender = {
  bot: "bot",
  human: "human",
  human_agent: "human_agent",
  system: "system",
};

export const SystemMessages = {
  humanModeStartNotification: "humanModeStartNotification",
  humanModeEndNotification: "humanModeEndNotification",
};
